import React from 'react';

export const CountryCode = {
  AF: 'AF', AL: 'AL', DZ: 'DZ', AD: 'AD', AO: 'AO', AG: 'AG', AR: 'AR', AM: 'AM', AU: 'AU', AT: 'AT',
  AZ: 'AZ', BS: 'BS', BH: 'BH', BD: 'BD', BB: 'BB', BY: 'BY', BE: 'BE', BZ: 'BZ', BJ: 'BJ', BT: 'BT',
  BO: 'BO', BA: 'BA', BW: 'BW', BR: 'BR', BN: 'BN', BG: 'BG', BF: 'BF', BI: 'BI', KH: 'KH', CM: 'CM',
  CA: 'CA', CV: 'CV', CF: 'CF', TD: 'TD', CL: 'CL', CN: 'CN', CO: 'CO', KM: 'KM', CG: 'CG', CR: 'CR',
  CI: 'CI', HR: 'HR', CU: 'CU', CY: 'CY', CZ: 'CZ', CD: 'CD', DK: 'DK', DJ: 'DJ', DM: 'DM', DO: 'DO',
  EC: 'EC', EG: 'EG', SV: 'SV', GQ: 'GQ', ER: 'ER', EE: 'EE', SZ: 'SZ', ET: 'ET', FJ: 'FJ', FI: 'FI',
  FR: 'FR', GA: 'GA', GM: 'GM', GE: 'GE', DE: 'DE', GH: 'GH', GR: 'GR', GD: 'GD', GT: 'GT', GN: 'GN',
  GW: 'GW', GY: 'GY', HT: 'HT', HN: 'HN', HK: 'HK', HU: 'HU', IS: 'IS', IN: 'IN', ID: 'ID', IR: 'IR',
  IQ: 'IQ', IE: 'IE', IL: 'IL', IT: 'IT', JM: 'JM', JP: 'JP', JO: 'JO', KZ: 'KZ', KE: 'KE', KI: 'KI',
  XK: 'XK', KW: 'KW', KG: 'KG', LA: 'LA', LV: 'LV', LB: 'LB', LS: 'LS', LR: 'LR', LY: 'LY', LI: 'LI',
  LT: 'LT', LU: 'LU', MO: 'MO', MG: 'MG', MW: 'MW', MY: 'MY', MV: 'MV', ML: 'ML', MT: 'MT', MH: 'MH',
  MR: 'MR', MU: 'MU', MX: 'MX', FM: 'FM', MD: 'MD', MC: 'MC', MN: 'MN', ME: 'ME', MA: 'MA', MZ: 'MZ',
  MM: 'MM', NA: 'NA', NR: 'NR', NP: 'NP', NL: 'NL', NZ: 'NZ', NI: 'NI', NE: 'NE', NG: 'NG', KP: 'KP',
  MK: 'MK', NO: 'NO', OM: 'OM', PK: 'PK', PW: 'PW', PS: 'PS', PA: 'PA', PG: 'PG', PY: 'PY', PE: 'PE',
  PH: 'PH', PL: 'PL', PT: 'PT', QA: 'QA', RO: 'RO', RU: 'RU', RW: 'RW', KN: 'KN', LC: 'LC', VC: 'VC',
  WS: 'WS', SM: 'SM', ST: 'ST', SA: 'SA', SN: 'SN', RS: 'RS', SC: 'SC', SL: 'SL', SG: 'SG', SK: 'SK',
  SI: 'SI', SB: 'SB', SO: 'SO', ZA: 'ZA', KR: 'KR', SS: 'SS', ES: 'ES', LK: 'LK', SD: 'SD', SR: 'SR',
  SE: 'SE', CH: 'CH', SY: 'SY', TW: 'TW', TJ: 'TJ', TZ: 'TZ', TH: 'TH', TL: 'TL', TG: 'TG', TO: 'TO',
  TT: 'TT', TN: 'TN', TR: 'TR', TM: 'TM', TV: 'TV', UG: 'UG', UA: 'UA', AE: 'AE', GB: 'GB', US: 'US',
  UY: 'UY', UZ: 'UZ', VU: 'VU', VA: 'VA', VE: 'VE', VN: 'VN', YE: 'YE', ZM: 'ZM', ZW: 'ZW'
} as const;

export type CountryCodeType = typeof CountryCode[keyof typeof CountryCode];

const orderedCodes = [
  'AF', 'AL', 'DZ', 'AD', 'AO', 'AG', 'AR', 'AM', 'AU', 'AT', 'AZ', 'BS', 'BH', 'BD', 'BB', 'BY', 'BE', 'BZ', 'BJ', 'BT',
  'BO', 'BA', 'BW', 'BR', 'BN', 'BG', 'BF', 'BI', 'KH', 'CM', 'CA', 'CV', 'CF', 'TD', 'CL', 'CN', 'CO', 'KM', 'CG', 'CR',
  'CI', 'HR', 'CU', 'CY', 'CZ', 'CD', 'DK', 'DJ', 'DM', 'DO', 'EC', 'EG', 'SV', 'GQ', 'ER', 'EE', 'SZ', 'ET', 'FJ', 'FI',
  'FR', 'GA', 'GM', 'GE', 'DE', 'GH', 'GR', 'GD', 'GT', 'GN', 'GW', 'GY', 'HT', 'HN', 'HK', 'HU', 'IS', 'IN', 'ID', 'IR',
  'IQ', 'IE', 'IL', 'IT', 'JM', 'JP', 'JO', 'KZ', 'KE', 'KI', 'XK', 'KW', 'KG', 'LA', 'LV', 'LB', 'LS', 'LR', 'LY', 'LI',
  'LT', 'LU', 'MO', 'MG', 'MW', 'MY', 'MV', 'ML', 'MT', 'MH', 'MR', 'MU', 'MX', 'FM', 'MD', 'MC', 'MN', 'ME', 'MA', 'MZ',
  'MM', 'NA', 'NR', 'NP', 'NL', 'NZ', 'NI', 'NE', 'NG', 'KP', 'MK', 'NO', 'OM', 'PK', 'PW', 'PS', 'PA', 'PG', 'PY', 'PE',
  'PH', 'PL', 'PT', 'QA', 'RO', 'RU', 'RW', 'KN', 'LC', 'VC', 'WS', 'SM', 'ST', 'SA', 'SN', 'RS', 'SC', 'SL', 'SG', 'SK',
  'SI', 'SB', 'SO', 'ZA', 'KR', 'SS', 'ES', 'LK', 'SD', 'SR', 'SE', 'CH', 'SY', 'TW', 'TJ', 'TZ', 'TH', 'TL', 'TG', 'TO',
  'TT', 'TN', 'TR', 'TM', 'TV', 'UG', 'UA', 'AE', 'GB', 'US', 'UY', 'UZ', 'VU', 'VA', 'VE', 'VN', 'YE', 'ZM', 'ZW'
];

export const CountryIdToCode: Record<number, CountryCodeType> = {};
orderedCodes.forEach((code, index) => {
  CountryIdToCode[index + 1] = code as CountryCodeType;
});

const displayNames = new Intl.DisplayNames(['en'], { type: 'region' });

export const CountryNameToCode: Record<string, CountryCodeType> = {};
orderedCodes.forEach((code) => {
  const name = displayNames.of(code);
  if (name) CountryNameToCode[name] = code as CountryCodeType;
});

Object.assign(CountryNameToCode, {
  USA: 'US',
  UAE: 'AE',
  'Czech Republic': 'CZ',
  'Ivory Coast': 'CI',
  Russia: 'RU',
  'South Korea': 'KR',
  'North Korea': 'KP',
  Macao: 'MO',
  'Vatican City': 'VA',
  Palestine: 'PS',
  'Democratic Republic of the Congo': 'CD',
  'Republic of the Congo': 'CG',
  Congo: 'CG',
} satisfies Record<string, CountryCodeType>);

function resolveCodeFromName(name: string): CountryCodeType | undefined {
  const trimmed = name.trim();
  if (!trimmed) return undefined;
  if (CountryNameToCode[trimmed]) return CountryNameToCode[trimmed];
  const lower = trimmed.toLowerCase();
  const match = Object.entries(CountryNameToCode).find(
    ([key]) => key.toLowerCase() === lower,
  );
  return match?.[1] as CountryCodeType | undefined;
}

interface CountryFlagProps {
  countryFlag?: string | CountryCodeType;
  countryId?: number | string;
  countryName?: string;
  className?: string;
}

const CountryFlag: React.FC<CountryFlagProps> = ({ countryFlag, countryId, countryName, className }) => {
  let resolvedCode = countryFlag;

  if ((!resolvedCode || typeof resolvedCode !== 'string' || resolvedCode.length !== 2) && countryId) {
    resolvedCode = CountryIdToCode[Number(countryId)];
  }

  if ((!resolvedCode || typeof resolvedCode !== 'string' || resolvedCode.length !== 2) && countryName) {
    resolvedCode = resolveCodeFromName(countryName);
  }

  if (!resolvedCode || typeof resolvedCode !== 'string' || resolvedCode.length !== 2) {
    return <span className={className} title={countryName || 'Unknown Country'} />;
  }

  const code = resolvedCode.toLowerCase();

  return (
    <img
      src={`https://flagcdn.com/${code}.svg`}
      alt={countryName || resolvedCode}
      title={countryName || resolvedCode}
      className={className}
      style={{
        width: '1.25em',
        height: '1em',
        objectFit: 'cover',
        borderRadius: '2px',
        display: 'inline-block',
        verticalAlign: 'middle',
        marginRight: '6px',
        boxShadow: '0 0 1px rgba(0,0,0,0.2)'
      }}
    />
  );
};

export default CountryFlag;
